module.exports = __webpack_public_path__ + "static/divider12-533c5d3cc15830aee96646d7a5f8344f.svg";